@if (!this.router.url.includes('login')) {
    <header class="app-header">
        <a class="skip-link" href="#contenido" (click)="saltarAlContenido($event)">Saltar al contenido</a>
        <div class="app-header__bar">
            <a class="brand" routerLink="/home" aria-label="Censo FFSJ, ir a Inicio">
                <img src="assets/img/logofede.png" alt="" width="44" height="44">
                <span><strong>Censo FFSJ</strong><small>Federació de Les Fogueres de Sant Joan</small></span>
            </a>

            <nav id="nav-principal" class="app-nav" [class.open]="menuAbierto()" aria-label="Navegación principal">
                <ul>
                    <li><a class="app-nav__link" routerLink="/home" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-house-door-fill" aria-hidden="true"></i>Inicio</a></li>
                    @if (verAsociaciones) {
                        <li><a class="app-nav__link" routerLink="/asociaciones" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-people-fill" aria-hidden="true"></i>Asociaciones</a></li>
                    }
                    @if (permisos.tieneGlobal('asociados:consultar')) {
                        <li><a class="app-nav__link" routerLink="/asociados" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-person-fill" aria-hidden="true"></i>Asociados</a></li>
                        <li><a class="app-nav__link" routerLink="/cargos" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-award-fill" aria-hidden="true"></i>Cargos</a></li>
                        <li><a class="app-nav__link" routerLink="/ejercicios" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-calendar-fill" aria-hidden="true"></i>Ejercicios</a></li>
                        <li><a class="app-nav__link" routerLink="/historico" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-archive-fill" aria-hidden="true"></i>Histórico</a></li>
                    }
                    @if (hayAdministracion) {
                        <li class="dropdown">
                            <span class="app-nav__group-title" id="grupo-admin">Administración</span>
                            <button type="button" class="app-nav__trigger dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-testid="menu-administracion">
                                <i class="bi bi-gear-fill" aria-hidden="true"></i>Administración
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="grupo-admin">
                                @if (permisos.tieneGlobal('acceso:bloqueos:consultar')) {
                                    <li><a class="dropdown-item" routerLink="/administracion/bloqueos-acceso" routerLinkActive="active">Bloqueos de acceso</a></li>
                                }
                                @if (permisos.tieneGlobal('asociaciones:estado')) {
                                    <li><a class="dropdown-item" routerLink="/administracion/asociaciones" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-toggles" aria-hidden="true"></i>Administración de asociaciones</a></li>
                                }
                                @if (permisos.tieneGlobal('permisos:gestionar')) {
                                    <li><a class="dropdown-item" routerLink="/permisos" routerLinkActive="active" ariaCurrentWhenActive="page"><i class="bi bi-shield-lock-fill" aria-hidden="true"></i>Permisos</a></li>
                                }
                            </ul>
                        </li>
                    }
                </ul>
            </nav>

            <div class="app-header__actions">
                <div class="dropdown account">
                    <button type="button" class="account-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Cuenta y sesión" data-testid="menu-cuenta">
                        <span class="avatar" aria-hidden="true"><i class="bi bi-person-fill"></i></span>
                        <span class="label">Mi cuenta<small>{{ cuenta() }}</small></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li><span class="dropdown-item-text small text-muted">{{ cuenta() }}</span></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><button type="button" class="dropdown-item" data-testid="cerrar-sesion" (click)="logout()"><i class="bi bi-box-arrow-right" aria-hidden="true"></i>Cerrar sesión</button></li>
                    </ul>
                </div>
                <button type="button" class="nav-toggle" aria-controls="nav-principal" [attr.aria-expanded]="menuAbierto()" aria-label="Menú de navegación" (click)="alternarMenu()">
                    <i class="bi" [class.bi-list]="!menuAbierto()" [class.bi-x-lg]="menuAbierto()" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <app-migas></app-migas>
    </header>
}
